// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ViewList from "@material-ui/icons/ViewList";
import example_csv from "assets/images/example_csv.png";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import axios from "axios";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Papa from "papaparse";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import "react-table/react-table.css";
import { api_url, gooSync_windows } from "redux/config.js";
import { verifyEmail } from "utils/Validate.jsx";
import Toast from "views/Toast/Toast";
import EmailListForm from "./EmailListForm";
import EmaillistTable from "./EmaillistTable";

const styles = {
  ...regularFormsStyle,
  ...sweetAlertStyle,
  descriptionTextArea: {
    width: "100%",
    height: 150
  },
  zeroZindex: {
    zIndex: 0
  }
};

class EditEmailList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data: null,
      newEmail: {},
      csvFile: null,
    };
  }
  componentDidMount() {
    this.onLoad();
  }
  onLoad = () => {
    let self = this;
    const { t } = this.props

    const url = api_url + `emaillist/get/`;
    const header = "Bearer ".concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: "LOAD_START" });
    axios({
      url,
      method: "get",
      params: {
        id: this.state.id
      },
      headers
    })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            data: response.data.data
          });
        } else {
          Toast(400, response.data.error)
        }
        self.props.dispatch({ type: "LOAD_END" });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: "LOAD_END" });
        if (!errors.response) {
          Toast(500, t("Connection error!"));
          return;
        }
        Toast(errors.response.status);
      });
  };

  // A phone list identifies its recipients by number instead of address, which changes the add
  // form, the CSV columns and the table below. Defaults to an email list while the data loads.
  isPhoneList = () => !!(this.state.data && this.state.data.kind === 'phone');

  setNewEmail = (name, value) => {
    let newEmail = this.state.newEmail;
    newEmail[name] = value;
    this.setState({
      newEmail
    });
  };
  confirmAddEmail = () => {
    let self = this;
    const { t } = this.props

    const isPhone = this.isPhoneList();
    const url = api_url + `emaillist/add_email`;
    const header = "Bearer ".concat(this.props.user.token);
    const data = {
      id: this.state.id,
      newEmail: this.state.newEmail
    };
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.hideAlert();
    this.props.dispatch({ type: "LOAD_START" });
    axios({
      url,
      method: "post",
      headers,
      data
    })
      .then(function (response) {
        self.props.dispatch({ type: "LOAD_END" });
        if (!response.data.success) {
          // The server names the reason; turn its code into something a hotelier can act on.
          // (This used to report success and the failure at the same time.)
          const codes = {
            invalid_phone: t('That phone number is not valid. Write it with the country code, e.g. +306912345678.'),
            invalid_email: t('That email address is not valid.'),
          };
          Toast(400, codes[response.data.error] || response.data.error);
          return;
        }
        self.setState({
          data: response.data.data
        });
        Toast(200, isPhone ? t("New phone added!") : t("New email added!"));
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: "LOAD_END" });
        if (!errors.response) {
          Toast(500, t("Connection error!"));
          return;
        }
        Toast(errors.response.status);
      });
  };
  removeEmail = (newemails) => {
    const { t } = this.props
    const isPhone = this.isPhoneList();
    let self = this;
    const url = api_url + `emaillist/remove_email`;
    const header = "Bearer ".concat(this.props.user.token);
    const data = {
      id: this.state.id,
      newEmails: newemails
    };
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.hideAlert();
    this.props.dispatch({ type: "LOAD_START" });
    axios({
      url,
      method: "post",
      headers,
      data
    })
      .then(function (response) {
        self.props.dispatch({ type: "LOAD_END" });
        if (!response.data.success) { Toast(400, response.data.error); return; }
        self.setState({
          data: response.data.data
        });
        Toast(200, isPhone ? t('Phone removed!') : t('Email removed!'));
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: "LOAD_END" });
        if (!errors.response) {
          Toast(500, t("Connection error!"));
          return;
        }
        Toast(errors.response.status);
      });
  }
  addEmail = () => {
    const { classes, t } = this.props;
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={this.isPhoneList() ? t('Add phone to list') : t('Add e-mail to list')}
          onConfirm={() => this.confirmAddEmail()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          <CustomInput
            labelText={t("Title")}
            id="Title"
            formControlProps={{
              onChange: e => this.setNewEmail("title", e.target.value),
              fullWidth: true
            }}
            inputProps={{
              type: "Text"
            }}
          />
          <CustomInput
            labelText={t("Name")}
            id="Name"
            formControlProps={{
              onChange: e => this.setNewEmail("name", e.target.value),
              fullWidth: true
            }}
            inputProps={{
              type: "Text"
            }}
          />
          {this.isPhoneList()
            ? <CustomInput
              labelText={t("Mobile phone") + ' (+30 69…)'}
              id="Phone"
              formControlProps={{
                fullWidth: true,
                onChange: e => this.setNewEmail("phone", e.target.value)
              }}
              inputProps={{
                type: "Text"
              }}
            />
            : <CustomInput
              labelText={t("Email")}
              id="Email"
              formControlProps={{
                fullWidth: true,
                onChange: e => this.setNewEmail("email", e.target.value)
              }}
              inputProps={{
                type: "Text"
              }}
            />}
          {/* The room / table travels with the recipient so their answer is location-tagged the
              same way a per-location QR answer is. */}
          <CustomInput
            labelText={t("Location (room / table)")}
            id="Location"
            formControlProps={{
              fullWidth: true,
              onChange: e => this.setNewEmail("location", e.target.value)
            }}
            inputProps={{
              type: "Text"
            }}
          />
        </SweetAlert>
      )
    });
  };
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  uploadCSV = () => {
    const { t } = this.props;
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-200px" }}
          title="Import CSV"
          onConfirm={() => this.handleUpload()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          <CustomInput
            labelText="CSV file"
            id="CSVfile"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "file",
              onChange: (e) => this.setState({ csvFile: e.target.files[0] })
            }}
          />
          {this.isPhoneList()
            ? <div style={{ textAlign: 'left' }}>
              <b>* {t('Columns, in this order')}:</b>
              <div style={{ fontFamily: 'monospace', margin: '6px 0' }}>
                phone, title, name, location
              </div>
              <div style={{ fontSize: 13 }}>
                {t('Only the number is required. Write it with the country code (+30…); numbers that cannot be dialled are skipped and reported.')}
              </div>
            </div>
            : <React.Fragment>
              <b>* CSV file should have following type of DATA</b>
              <img src={example_csv} />
              <div style={{ fontSize: 13, marginTop: 6 }}>
                {t('An optional 4th column is imported as the location (room / table).')}
              </div>
            </React.Fragment>}
        </SweetAlert>
      )
    });
  }
  handleUpload = () => {

    let self = this;
    let file = this.state.csvFile;
    if (!file) {
      Toast(400, 'Please select csv file');
      return;
    }
    const phoneList = this.isPhoneList();
    const { t } = this.props;
    Papa.parse(file, {
      complete: function (results, file) {
        let emails = []
        for (let i = 0; i < results.data.length; i++) {
          const item = results.data[i]
          if (!item || !item.length) continue;
          if (phoneList) {
            // phone, title, name, location — the number is the only required column, and the
            // server normalises it to E.164 and rejects anything it cannot dial.
            const phone = String(item[0] || '').trim();
            if (!phone || !/\d/.test(phone)) continue;      // skips a header row too
            emails.push({ phone, title: item[1], name: item[2], location: item[3] })
          } else {
            if (!verifyEmail(item[0])) continue;
            // email, title, name, location — location is new and optional, so files with the
            // original three columns import exactly as before.
            if (item.length >= 2 && item.length <= 4) {
              emails.push({ email: item[0], title: item[1], name: item[2], location: item[3] })
            }
          }
        }

        if (emails.length > 0) {
          self.addMultipleEmails(emails)
        } else {
          Toast(400, phoneList ? t('No phone numbers found') : "Not found emails")
        }
      },
      delimiter: ",",
      error: function (err, file, inputElem, reason) {
        Toast(400, err.message)
      },
    })
  }

  addMultipleEmails = (emails) => {
    const { t } = this.props;
    // De-duplicate against whichever column identifies a recipient in this list. (The server
    // de-duplicates again on insert; this only avoids sending rows it would reject.)
    const key = this.isPhoneList() ? 'phone' : 'email';
    const current_emails = this.state.data.emails.map((item) => (item[key]))
    const non_repeated_emails = emails.filter((item) => {
      const index = current_emails.indexOf(item[key]);
      return index < 0;
    })
    if (non_repeated_emails.length > 0) {
      let self = this;
      const url = api_url + `emaillist/add_multi_email`;
      const header = "Bearer ".concat(this.props.user.token);
      const data = {
        id: this.state.id,
        multipleEmails: non_repeated_emails
      };
      let headers = null;
      if (this.props.user.token) {
        headers = {
          Authorization: header
        };
      }
      this.hideAlert();
      this.props.dispatch({ type: "LOAD_START" });
      axios({
        url,
        method: "post",
        headers,
        data
      })
        .then(function (response) {
          if (response.data.success) {
            self.setState({
              data: response.data.data
            });
            // Always say how many rows landed, and how many the server refused. An import that
            // silently drops half a file is the kind of quiet failure that only surfaces later,
            // as a campaign that reaches nobody.
            const skipped = response.data.skipped || 0;
            const added = response.data.added || 0;
            if (skipped) {
              Toast(400, t('{added} added, {skipped} skipped (unusable)')
                .replace('{added}', added).replace('{skipped}', skipped));
            } else {
              Toast(200, t('{added} added').replace('{added}', added));
            }
          } else {
            Toast(400, response.data.error)
          }
          self.props.dispatch({ type: "LOAD_END" });
        })
        .catch(function (errors) {
          console.info(errors);
          self.props.dispatch({ type: "LOAD_END" });
          if (!errors.response) {
            Toast(500, "Connection error!");
            return;
          }
          Toast(errors.response.status);
        });
    } else {
      this.hideAlert();
      Toast(200, "There is no new emails.");
    }
  }
  render() {
    const { classes, t } = this.props;
    if (!this.state.data) return null;
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <EmailListForm
              id={this.state.id}
              name={this.state.data.name}
              kind={this.state.data.kind}
              onSave={() => {
                Toast(200, "Successfully updated");
              }}
            />
          </GridItem>
          {/* The desktop sync app feeds email lists only, so it would just confuse on a phone list. */}
          {!this.isPhoneList() &&
            <GridItem xs={12} sm={12}>
              <Card>
                <CardHeader color="success" icon>
                  <CardIcon color="success">
                    <ViewList />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>{t('Syncronize with local csv files')}</h4>
                </CardHeader>
                <CardBody>

                  <p>{t('This ID will be used to sync local csv files with this email list')}</p>
                  <b>{this.state.id}</b>
                  <h3>{t('Download Sync app here')}</h3>
                  <Button href={gooSync_windows} color="info">{t('WINDOWS')}</Button>
                </CardBody>
              </Card>
            </GridItem>}
          <GridItem xs={12} sm={12}>
            <EmaillistTable
              emails={this.state.data.emails}
              kind={this.state.data.kind}
              addEmail={this.addEmail}
              addMultipleEmails={this.addMultipleEmails}
              removeEmail={this.removeEmail}
              uploadCSV={this.uploadCSV}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(EditEmailList)));
